// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__2xoof","small":"Input_small__3iCjy","xsmall":"Input_xsmall__rKVSF"};